module.exports = __webpack_public_path__ + "client_dashboard.png?de23c99e30f3508449314c3de5f83807";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newborn/client_dashboard.png
// module id = 17
// module chunks = 0